import { render, staticRenderFns } from "./Checkout-bank-details.vue?vue&type=template&id=ceffa1f4&scoped=true&"
import script from "./Checkout-bank-details.vue?vue&type=script&lang=js&"
export * from "./Checkout-bank-details.vue?vue&type=script&lang=js&"
import style0 from "./Checkout-bank-details.vue?vue&type=style&index=0&id=ceffa1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceffa1f4",
  null
  
)

export default component.exports